import React, { useEffect, useState } from "react";
import ApiDatabase from "server";
import UseContext from "hooks/useContext";
import useModal from "components/modal/useModal";
import Button from "components/button";
import { AddIcon } from "assets/icons";
import TeamItem from "components/teamItem/TeamItem";

/** Même grille que Workfully company (SettingsTeam / TeamItem). */
const ROW_GRID = "grid grid-cols-5";

const TeamTableSkeleton = () => (
    <>
        {[1, 2, 3, 4].map((index) => (
            <div
                key={index}
                className={`${ROW_GRID} animate-pulse border-b border-gray-100 p-4 text-sm`}
            >
                <div className={"col-span-3"}>
                    <div className={"flex gap-6"}>
                        <div
                            className={
                                "h-10 w-10 rounded-full bg-gray-200 shrink-0"
                            }
                        />
                        <div className={"flex flex-col gap-1"}>
                            <div
                                className={"h-4 w-32 rounded bg-gray-200"}
                            />
                            <div
                                className={"h-4 w-40 rounded bg-gray-200"}
                            />
                        </div>
                    </div>
                </div>
                <div className={"flex items-center"}>
                    <div className={"h-4 w-40 rounded bg-gray-200"} />
                </div>
                <div className={"flex items-center justify-end"}>
                    <div className={"h-8 w-8 rounded bg-gray-200"} />
                </div>
            </div>
        ))}
    </>
);

const TeamContent = () => {
    const { companyData, setStaffData, staffData, refreshStaff, rest } =
        UseContext();
    const { toggle } = useModal();
    const [isWaiting, setIsWaiting] = useState(false);

    useEffect(() => {
        if (!companyData?._id || !Object.keys(companyData).length) return;
        let cancelled = false;
        setIsWaiting(true);
        ApiDatabase.postStaffArray(
            { staff: companyData.employees, id_company: companyData._id },
            (data) => {
                if (cancelled) return;
                setStaffData(data);
                setIsWaiting(false);
            },
            (err) => {
                if (cancelled) return;
                console.log("Error fetching staff:", err);
                setIsWaiting(false);
            }
        );
        return () => {
            cancelled = true;
        };
    // Ne pas dépendre de tout `companyData` (réf. qui change à chaque re-fetch) : chaque ligne TeamItem appelait useFetchData → getCompanyProfile en boucle.
    }, [companyData?._id, refreshStaff]);

    const handleAdd = () => {
        toggle("admin_c_add");
    };

    const members = Array.isArray(staffData) ? staffData : [];

    return (
        <div className="w-full px-2 tab:px-4 lg:px-8 py-8">
            <div className="flex flex-col gap-8 max-w-3xl">
                <div className="flex flex-col gap-6">
                    <div className="flex flex-wrap items-center justify-between gap-4">
                        <h2 className="text-xl font-medium text-gray-900">
                            Équipe
                        </h2>
                        {rest === 0 ? null : (
                            <Button
                                size={"LGI"}
                                color={"PRIMARYFIXE"}
                                onClick={handleAdd}
                            >
                                <AddIcon wh={14} color={"#ffffff"} />
                                Inviter un membre
                            </Button>
                        )}
                    </div>

                    <div className="flex flex-col">
                        <div
                            className={`${ROW_GRID} border-b border-gray-100 p-4 text-sm text-gray-500 uppercase tracking-wide`}
                        >
                            <div className={"col-span-3"}>
                                MEMBRES{!isWaiting && ` (${members.length})`}
                            </div>
                            <div>RÔLE</div>
                        </div>
                        {isWaiting ? (
                            <TeamTableSkeleton />
                        ) : (
                            members.length > 0 &&
                            members.map((member) => (
                                <TeamItem
                                    member={member}
                                    key={member._id}
                                />
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamContent;
